import { absoluteFill, breakpoints, calcEm, calcPerc, 
  css, dimensions, fluidFontSize, fluidRange, fontSmoothing, 
  respondTo, styled 
} from '~/styles';
import { Button } from '~/components/common';



export const baseFontSize = 92;
export interface PageContainerProps {
  bgImage?: string;
}
const bgFadeOutHeight = 100;
export const PageContainer = styled.div<PageContainerProps>`
  position: relative;
  text-align: center;

  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${p => p.bgImage ? css`
    &:before {
      content: '';
      ${absoluteFill};
      height: calc(100vh - ${dimensions.headerHeight.desktop}px);

      z-index: -1;
      pointer-events: none;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url(${p.bgImage});
      margin-bottom: -50px;

      ${respondTo(breakpoints.md, css`
        height: calc(100vh - ${dimensions.headerHeight.mobile}px);
      `)}
    }

    /* gradient at the edge of image (for pages with h > 100vh) */
    &:after {
      content: '';
      position: absolute;
      top: calc(100vh - ${dimensions.headerHeight.desktop}px);
      left: 0;
      width: 100%;
      height: ${bgFadeOutHeight}px;
      background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
      z-index: -1;
      transform: translateY(-100%);
    }
  ` : null}
`

export interface TopContainerProps {
  bgImage?: string;
  addGradient?: boolean;
}
export const TopContainer = styled.div<TopContainerProps>`
  position: relative;
  flex: 1 1 ${calcPerc(620, 920)};
  display: flex;
  flex-flow: column;
  justify-content: center;
  ${fontSmoothing};

  /* basic font size for top container - elements inside are scaled based on that */
  ${fluidFontSize(38, 92)}
  
  ${fluidRange(
    'paddingLeft',
    `${dimensions.containerPadding.min}px`,
    `${dimensions.containerPadding.max}px`
  )}
  ${fluidRange(
    'paddingRight',
    `${dimensions.containerPadding.min}px`,
    `${dimensions.containerPadding.max}px`
  )}

  ${p => p.bgImage && css`
    &:before {
      content: '';
      ${absoluteFill};
      z-index: -1;
      pointer-events: none;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url(${p.bgImage});
    }
  `}


  ${p => p.addGradient && css`
    /* bottom gradient */
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50%;
      background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);
      transform: translateY(50%);
      z-index: -1;
    }
  `}
`

export const BottomContainer = styled.div`
  flex: 0 0 ${calcPerc(300, 920)};
  background: rgba(0, 0, 0, 0.2);

  display: flex;
  flex-flow: row;
  justify-content: space-between;


  ${respondTo(
    breakpoints.lg,
    css`
      display: block;
    `
  )}
`

export const PageHeadline = styled.h1`
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 300;

  line-height: 1.15;
  text-align: center;

  b { 
    font-weight: 900;
  }

  span {
    white-space: nowrap;
  }
`

export const PageOverHeadline = styled.h5`
  font-size: ${calcEm(21.5, 92)};
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-weight: 500;
  margin-bottom: 1.5em;
  text-align: center;
`

export const PageComingSoon = styled.h5`
  font-size: ${calcEm(46, baseFontSize)};
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-weight: 300;
  text-align: center;
`

export const HeadlineHr = styled.hr`
  width: ${calcEm(425, baseFontSize)};
  max-width: 58vw;
  margin: 0 auto;
  margin-bottom: ${calcEm(34, baseFontSize)};
`

export const HeadlineParagraph = styled.p`
  ${fluidRange('fontSize', '10px', '18px')}
  font-weight: 500;
  width: ${calcEm(400, 18)};
  max-width: 58vw;
  margin: 0 auto;
  margin-bottom: 1.5em;
  line-height: 1.43;

  ${respondTo(breakpoints.md, css`
    width: 70vw;
    max-width: none;
  `)}
`

export const ButtonCTA = styled(Button)`
  font-size: ${calcEm(20.5, baseFontSize)} !important;
`


// WEBPACK FOOTER //
// ./src/components/layout/PageBasics.tsx